import React,{useState,useEffect} from 'react'
import { HeaderItem } from '../../../Components/componenetsPubDown/HeaderItem'
import { Header } from '../../../Components/componenetsPubDown/Header'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import WidgetsPage from '../../modules/widgets/WidgetsPage'
import WizardsPage from '../../modules/wizards/WizardsPage'
import { Feeds } from '../../modules/widgets/components/Feeds'
import { Mixed } from '../../modules/widgets/components/Mixed'
import { MixedWidget7 } from '../../../_metronic/partials/widgets'
import ItemPubDown from '../../../Components/componenetsPubDown/ItemPubDown'
import axios from 'axios'
import { toast,ToastContainer } from 'react-toastify'
import { log } from 'console'
import { Loading } from '../Loading'

export default function ListPubDown() {


  
  const usersBreadcrumbs: Array<PageLink> = [
    {
      title: 'Gestion Publicités',
      path: '/pages/managementmachines/listmachine',
      isSeparator: false,
      isActive: false,
    }
  ]
  const [pub1, setPub1] = useState([])
  const [loading, setLoading] = useState(true)

  const deletePub = (id: number) => {
    console.log(id);
    
    if (window.confirm("voulez-vous vraimenet supprimer cet utilisateur !")) {
      const filteredpub1 = pub1.filter((pub: any) => pub.id !== id);
          setPub1(filteredpub1);    
            toast.success("pub supprimé");

      axios
        .delete("https://api.machinery.fcpo.ma/api/pub1s/" + id)
        .then(() => {
        
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };
  const getPub1=()=>{
    axios.get("https://api.machinery.fcpo.ma/api/pub1s.json").then(
      (response)=>{
        console.log(response.data);
        
             setPub1(response.data)
             setLoading(false)
      }
    )
  }
  useEffect(() => {
    getPub1()
  }, [])
  
  return (
    <>
    <ToastContainer/>
    <Header/>
        <PageTitle breadcrumbs={usersBreadcrumbs}>List Pub</PageTitle>
        <div className='row g-5 g-xl-8'>
          {
loading?<Loading/>:
pub1.map((pub,index)=>{
  return     <ItemPubDown
  deletePub={deletePub} 
  key={index}
  data={pub}
  className='card-xl-stretch mb-xl-8'
  chartColor=''
  chartHeight='200px'
/>  
})
}
          
    
    
     
      
         
      
        
      </div>
    </>
  )
}
